import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatOption, MatSelect } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PROJECTSTATUSREPORT } from '../common/constants/labels';
import { ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { IncidentsDashboardViewModel } from '../common/models/incident-dashboard-filterparameter';
import { PivotTableDetails } from '../common/models/incident-dashboard-filterparameterdata';
import { Role } from '../common/models/role';
import { AuthenticationService } from '../common/services/authentication.service';
import { DashboardSqlService } from '../dashboard-sql/dashboard-sql.service';
import { ExcelService } from '../dashboard-sql/excel.service';

@Component({
  selector: 'app-project-status-report',
  templateUrl: './project-status-report.component.html',
  styleUrls: ['./project-status-report.component.scss']
})
export class ProjectStatusReportComponent implements OnInit {
  title = 'Status Report';
  loading = true;
  pojectStatusReportCol = PROJECTSTATUSREPORT;
  ValidationMsg = 'Please select From Date, To Date,Cluster, Site, Big Category.';
  showValidationMessage = false;
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  cluster: string[] = [];
  site: string[] = [];
  bigcategory: string[] = [];
  clustertooltip = [];
  sitetooltip = [];
  bigcategorytooltip = [];
  qamatrixDashboardForm = new FormGroup({
    clusters: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
    YearlyControl: new FormControl(),
    YearControl: new FormControl()
  });

  qamatrixDefects = new FormGroup({
    clusterFilter: new FormControl(),
    siteFilter: new FormControl(),
    bigCategoryFilter: new FormControl(),
    userFilter: new FormControl()
  });

  clusterFiltertooltip = [];
  siteFiltertooltip = [];
  bigcategoryFiltertooltip = [];
  userFiltertooltip = [];

  role;
  @ViewChild('clusterControl', {static: false}) clusterControl: MatSelect;
  @ViewChild('siteControl', {static: false}) siteControl: MatSelect;
  @ViewChild('bigCategoryControl', {static: false}) bigCategoryControl: MatSelect;

  @ViewChild('clusterFilter', {static: false}) clusterFilterControl: MatSelect;
  @ViewChild('siteFilter', {static: false}) siteFiltercontrol: MatSelect;
  @ViewChild('bigCategoryFilter', {static: false}) bigCategoryFilterControl: MatSelect;
  @ViewChild('userFilter', {static: false}) userFilterControl: MatSelect;

  allSelected = false;
  siteAllSelected = false;
  bigCategoryAllSelected = false;
  clusterdefault = [];
  sitedefault = [];
  bigcategorydefault = [];
  showSuccess = false;
  filterParameter: any;
  dataAvailable = false;
  filteredDataSource = [];
  pivotTableDetails = [];
  nofiltereddata = false;
  clusterfilter: string[] = [];
  sitefilter: string[] = [];
  bigcategoryfilter: string[] = [];
  userfilter: string[] = [];
  clusterfilterdefault: string[] = [];
  sitefilterdefault: string[] = [];
  bigcategoryfilterdefault: string[] = [];
  userfilterdefault: string[] = [];
  bigCategoryFilterSelectedAll = false;
  userFilterSelectedAll = false;
  siteFilterSelectedAll = false;
  clusterFilterSelectedAll = false;
  noRecords = 'No records';
  minDate: Date = new Date('01/01/2015');
  maxDate: Date = new Date();
  inputReadonly = true;
  yearSelect = [];
  yearlySelect = [ 'H1', 'Full Year'];
  disableCluster = false;
  disableSite = false;
  agreementRemarksDate = '';
  showProjectStatusContent = false;
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  dataSource!: MatTableDataSource<any>;

  constructor(private dashboardService: DashboardSqlService, private datepipe: DatePipe, private excelService: ExcelService, private authenticateService: AuthenticationService) { }

  ngOnInit() {
    this.loading = true;
    this.setYear();
    this.getClusterSiteBigCategoryData();
    this.nofiltereddata = true;
    this.noRecords = '';
    // this.loading = false;
  }

  setYear() {
    const currentYear = new Date().getFullYear();
    for (let i = 2020; i <= currentYear; i++) {
      this.yearSelect.push(i);
    }
  }

  commonfunctionSetDefault(tempArray: string[], bigArray: string[]) {
    this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.sitedefault = this.sitedefault.length > 0 ? this.sitedefault : this.site;
    this.bigcategory = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    this.bigcategorydefault = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;
    // this.assignSelectionFromUploadFile();
    this.clustertooltip = this.clusterdefault.length > 0 ? this.clusterdefault : this.cluster;
    this.sitetooltip = this.sitedefault.length > 0 ? this.sitedefault : this.site;
    this.bigcategorytooltip = this.bigcategorydefault.length > 0 ? this.bigcategorydefault : this.bigcategory;

    if (this.cluster.length <= this.clusterdefault.length) {
      this.allSelected = true;
    }

    let siteAll = false;
    if (this.site.length <= this.sitedefault.length) {
      siteAll = true;
      this.siteControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          siteAll = false;
        }
      });
      this.siteAllSelected = siteAll;
    }

    let bigCategoryAll = false;
    if (this.bigcategory.length <= this.bigcategorydefault.length) {
      bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
    }

    if (this.role === Role.qualityChampion) {
      this.disableSite = false;
      this.disableCluster = true;
    } else if (this.role === Role.globalAdmin || this.role === Role.qualityGlobalRead) {
      this.disableSite = false;
      this.disableCluster = false;
    } else {
      this.disableSite = true;
      this.disableCluster = true;
    }
  }

  selectClusterSiteDropdownwithdefault() {
    this.loading = true;
    let factory = '';
    factory = localStorage.getItem('factory');
    const tempArray: string[] = [];
    const bigArray: string[] = [];
    const clustertemp: string[] = [];
    const sitetemp: string[] = [];
    const bigcategorytemp: string[] = [];
    /* this.clustersitebigcategoryArray.forEach(clusterfilter => {
      if (clusterfilter.factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, clusterfilter.site)) {
        if (clustertemp.indexOf(clusterfilter.clustername) === -1) {
          clustertemp.push(clusterfilter.clustername);
        }
        if (sitetemp.indexOf(clusterfilter.site) === -1) {
          sitetemp.push(clusterfilter.site);
        }
        if (bigcategorytemp.indexOf(clusterfilter.bigcategory) === -1) {
          bigcategorytemp.push(clusterfilter.bigcategory);
        }
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.clustername === element.clustername) {
            tempArray.push(element.site);
            // bigArray.push(element.bigcategory);
          }
        });
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.site === element.site) {
            bigArray.push(element.bigcategory);
          }
        });
      }
    }); */
    for (let i = 0; i < this.clustersitebigcategoryArray.length; i++) {
      const factoryname = this.clustersitebigcategoryArray[i].factoryname;
      const site  = this.clustersitebigcategoryArray[i].site;
      const bigcategory = this.clustersitebigcategoryArray[i].businessgroup;
      const clustername = this.clustersitebigcategoryArray[i].subregion;
      if (factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, site)) {
        if (clustertemp.indexOf(clustername) === -1) {
          clustertemp.push(clustername);
        }
        if (sitetemp.indexOf(site) === -1) {
          sitetemp.push(site);
        }
        if (bigcategorytemp.indexOf(bigcategory) === -1) {
          bigcategorytemp.push(bigcategory);
        }
        this.clustersitebigcategoryArray.forEach(element => {
          if (clustername === element.subregion) {
            tempArray.push(element.site);
            // bigArray.push(element.bigcategory);
          }
        });
        this.clustersitebigcategoryArray.forEach(element => {
          if (site === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        break;
      }
    }
    this.clusterdefault = clustertemp;
    this.sitedefault = sitetemp;
    this.bigcategory = bigcategorytemp;
    if (this.clusterdefault.length === 0) {
      const clusterdata = [];
      this.loading = true;
      this.role = localStorage.getItem('role');
      const clusterBasedOnRole = localStorage.getItem('clusterBasedOnRole');
      let clusterBasedOnRoleparsed = [];
      if (clusterBasedOnRole !== null && clusterBasedOnRole !== undefined) {
        clusterBasedOnRoleparsed = JSON.parse(clusterBasedOnRole);
        this.clusterdefault = clusterBasedOnRoleparsed;
        this.clustersitebigcategoryArray.forEach(element => {
          clusterBasedOnRoleparsed.forEach(x => {
            if (x === element.subregion) {
              tempArray.push(element.site);
              bigArray.push(element.businessgroup);
            }
          });
        });
        this.commonfunctionSetDefault(tempArray, bigArray);
        this.loading = false;
      } else {
        this.dashboardService.getClusterFromDFOS(this.role).subscribe((response) => {
          if (response !== null) {
            response.forEach(element => {
              clusterdata.push(element.name);
            });
            localStorage.setItem('clusterBasedOnRole', JSON.stringify(clusterdata));
            this.clusterdefault = clusterdata;
            this.clustersitebigcategoryArray.forEach(element => {
              clusterdata.forEach(x => {
                if (x === element.subregion) {
                  tempArray.push(element.site);
                  bigArray.push(element.businessgroup);
                }
              });
            });
            this.commonfunctionSetDefault(tempArray, bigArray);
          }
          this.loading = false;
        });
      }
    } else {
      this.commonfunctionSetDefault(tempArray, bigArray);
      this.loading = false;
    }
  }

  getClusterSiteBigCategoryData() {
    this.dashboardService.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
        this.showValidationMessage = true;
        this.loading = false;
      } else {
        // this.noRecordsShow = false;
        // const UpdatedResponse = [];
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectClusterSiteDropdownwithdefault();
        // this.loading = false;
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try again after sometime.';
      this.showValidationMessage = true;
      this.loading = false;
    });
  }

  loadSite() {
    this.loading = true;
    this.bigcategory = [];
    this.site = [];
    const tempArray: string[] = [];
    this.clustertooltip = [];
    this.sitetooltip = [];
    this.bigcategorytooltip = [];
    this.qamatrixDashboardForm.get('sites').setValue(null);
    let clusterSelected = [];
    if (this.qamatrixDashboardForm.get('clusters').value !== null && this.qamatrixDashboardForm.get('clusters').value.length > 0) {
      clusterSelected = this.qamatrixDashboardForm.get('clusters').value;
      this.clustertooltip = clusterSelected;
      let clusterAll = true;
      this.clusterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          clusterAll = false;
        }
      });
      this.allSelected = clusterAll;
      clusterSelected.forEach(clusterelement => {
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterelement === element.subregion) {
            tempArray.push(element.site);
          }
        });
      });
      this.site = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.sitedefault = this.site;
      this.sitetooltip = this.sitedefault;
      setTimeout(() => {
        this.loadBigCategory();
      }, 2000);
    } else {
      this.loading = false;
    }
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  clearData() {
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  loadBigCategory() {
    this.bigcategory = [];
    this.qamatrixDashboardForm.get('bigcategories').setValue(null);
    this.sitetooltip = [];
    this.bigcategorytooltip = [];
    let siteSelected = [];
    const tempBigCategoryArray: string[] = [];
    if (this.qamatrixDashboardForm.get('sites').value !== null && this.qamatrixDashboardForm.get('sites').value.length > 0) {
      siteSelected = this.qamatrixDashboardForm.get('sites').value;
      this.sitetooltip = siteSelected;
      siteSelected.forEach(siteelement => {
        this.clustersitebigcategoryArray.forEach(element => {
          if (siteelement === element.site) {
            tempBigCategoryArray.push(element.businessgroup);
          }
        });
      });
      this.bigcategory = tempBigCategoryArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
      this.bigcategorydefault = this.bigcategory;
      this.bigcategorytooltip = this.bigcategorydefault;
      let siteAll = true;
      this.siteControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          siteAll = false;
        }
      });
      this.siteAllSelected = siteAll;

      let bigCategoryAll = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          bigCategoryAll = false;
        }
      });
      this.bigCategoryAllSelected = bigCategoryAll;
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dataAvailable = false;
      this.noRecords = '';
      this.nofiltereddata = true;
      this.loading = false;
    }
  }

    // Authorization
    get isAuthorized() {
      this.role = localStorage.getItem('role');
      if (this.role === Role.globalAdmin) {
        return true;
      } else {
        return false;
      }
    }

    optionClick() {
      let newStatus = true;
      this.clusterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
      this.allSelected = newStatus;
    }

    optionclusterFilterClick() {
      let newStatus = true;
      this.clusterFilterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
      this.clusterFilterSelectedAll = newStatus;
    }

    optionsiteFilterClick() {
      let newStatus = true;
      this.siteFiltercontrol.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
      this.siteFilterSelectedAll = newStatus;
    }

    optionBigCategoryFilterClick() {
      let newStatus = true;
      this.bigCategoryFilterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
      this.bigCategoryFilterSelectedAll = newStatus;
    }

    optionUserFilterClick() {
      let newStatus = true;
      this.userFilterControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
      this.userFilterSelectedAll = newStatus;
    }

    toggleSiteAllSelection() {
      if (this.siteAllSelected) {
        this.siteControl.options.forEach((item: MatOption) => item.select());
      } else {
        this.siteControl.options.forEach((item: MatOption) => item.deselect());
        this.sitetooltip = [];
        this.bigcategorytooltip = [];
      }
    }
    optionsiteClick() {
      let newStatus = true;
      this.siteControl.options.forEach((item: MatOption) => {
      if (!item.selected) {
          newStatus = false;
        }
      });
      this.siteAllSelected = newStatus;
    }
    toggleBigCategoryAllSelection() {
     if (this.bigCategoryAllSelected) {
        this.bigCategoryControl.options.forEach((item: MatOption) => item.select());
      } else {
        this.bigCategoryControl.options.forEach((item: MatOption) => item.deselect());
        this.bigcategorytooltip = [];
      }
    }
    optionBigCategoryClick() {
      let newStatus = true;
      this.bigCategoryControl.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
      this.bigCategoryAllSelected = newStatus;
    }

    toggleAllSelection() {
      if (this.allSelected) {
        this.clusterControl.options.forEach((item: MatOption) => item.select());
      } else {
        this.clusterControl.options.forEach((item: MatOption) => item.deselect());
        this.clustertooltip = [];
        this.sitetooltip = [];
        this.bigcategorytooltip = [];
      }
    }

    generateReport() {
      this.loading = true;
      this.showValidationMessage = false;
      this.showSuccess = false;
      const year = + this.qamatrixDashboardForm.get('YearControl').value;
      console.log(year);
      let fromDate = '';
      let toDate = '';
      if (this.qamatrixDashboardForm.get('YearlyControl').value === 'H1' || this.qamatrixDashboardForm.get('YearlyControl').value === null) {
        fromDate = '07/01/' + year; // for H1, consider the date between 1-Jul to 31-dec of the selected year
        this.agreementRemarksDate = 'H1';
      } else {
        fromDate = '07/01/' + year; // for full year, consider the date between 1-Jul to 30-Jun of the selected (year + 1)
        this.agreementRemarksDate = 'Full Year';
      }
      if (this.qamatrixDashboardForm.get('YearlyControl').value === 'H1') {
        toDate = '12/31/' + year; // for H1, todate should be 31-dec of the selected year
      } else {
        toDate = '06/30/' + (year + 1); // for full year, todate should be 30-Jun of the selected (year + 1)
      }
      const selectedFromDate = fromDate;
      const selectedTodate = toDate;
      const selectedcluster = this.qamatrixDashboardForm.get('clusters').value;
      const selectedsite = this.qamatrixDashboardForm.get('sites').value;
      const selectedbigcategory = this.qamatrixDashboardForm.get('bigcategories').value;
      if (selectedFromDate === null || selectedFromDate === '' || selectedTodate === null || selectedTodate === ''
        || selectedcluster === null || selectedcluster === '' || selectedcluster.length === 0
        || selectedsite === null || selectedsite === '' || selectedsite.length === 0
        || selectedbigcategory === null || selectedbigcategory === '' || selectedbigcategory.length === 0) {
        if (!this.isAuthorized) {
          this.ValidationMsg = 'Please select From Date, To Date, Big Category.';
        } else {
          this.ValidationMsg = 'Please select From Date, To Date, Cluster, Site, Big Category.';
        }
        this.showValidationMessage = true;
        this.loading = false;
      } else {
        this.filterParameter = {
          fromDate: new Date(selectedFromDate).toLocaleDateString('en-US'),
          toDate: new Date(selectedTodate).toLocaleDateString('en-US'),
          bigcategory: selectedbigcategory,
          cluster: selectedcluster,
          site: selectedsite,
        };
        this.getPivotTableData(this.filterParameter);
      }
    }

    getPivotTableData(filterParameter: IncidentsDashboardViewModel) {
      this.showValidationMessage = false;
      this.showSuccess = false;
      this.dashboardService.getPivotTableData(filterParameter).subscribe((response) => {
        this.dataAvailable = true;
        if (response.pivotTableAgreement !== null && response.pivotTableAgreement.length > 1) {
          const pivotTable = [];
          response.pivotTableAgreement.forEach(e => {
            let object = {};
            object = {
              createddate: e.createddate,
              // createddate: this.agreementRemarksDate,
              startdate: e.startdate,
              enddate: e.enddate,
              subregion: e.subregion,
              sites: e.sites,
              businessgroup: e.businessgroup,
              defectmodeaggregation: e.defectmodeaggregation,
              level0: e.leveL0,
              fourms: e.fourms,
              // product: e.product,
              recordid: e.recordid,
              productionline: e.productionline.trim(),
              defectpriorityindex: e.defectpriorityindex,
              occurances: e.occurances,
              defectseveritygrade: e.defectseveritygrade,
              dpidefectclass: e.dpidefectclass,
              pdcastatus: e.pdcastatus,
              agreement: e.agreement,
              remarks: e.remarks,
              createdby: e.createdby
            };
            pivotTable.push(object);
          });
          this.filteredDataSource = pivotTable;
          this.pivotTableDetails = pivotTable;
          this.dataSource = new MatTableDataSource(this.filteredDataSource);
          this.dataSource.paginator = this.paginator;
          this.loading = false;
          this.showProjectStatusContent = true;
          this.filterData();
        } else {
          this.loading = false;
          this.ValidationMsg = 'No data available.';
          this.showValidationMessage = true;
          this.dataAvailable = false;
          this.noRecords = '';
          this.nofiltereddata = true;
        }
      }, (error) => {
        this.ValidationMsg = 'Failed to get report data. Please try again after sometime.';
        this.showValidationMessage = true;
        this.noRecords = '';
        this.nofiltereddata = true;
        this.loading = false;
      });
    }

    // dateValidation() {
    //   const CurrentDate = new Date();
    //   const dateToCheck = new Date(this.qamatrixDashboardForm.get('todate').value);
    //   const dateFromCheck = new Date(this.qamatrixDashboardForm.get('fromdate').value);
    //   if (dateToCheck > CurrentDate || dateFromCheck > CurrentDate) {
    //     this.ValidationMsg = 'Selected date should not be greater than current date.';
    //     this.showValidationMessage = true;
    //     return true;
    //   }
    //   if (this.qamatrixDashboardForm.get('fromdate').value != null && this.qamatrixDashboardForm.get('todate').value != null && Date.parse(this.qamatrixDashboardForm.get('fromdate').value) > Date.parse(this.qamatrixDashboardForm.get('todate').value)) {
    //     this.ValidationMsg = 'From Date should be less than To Date.';
    //     this.showValidationMessage = true;
    //     this.dataAvailable = false;
    //     this.noRecords = '';
    //     this.nofiltereddata = true;
    //     return true;
    //   } else {
    //     this.showValidationMessage = false;
    //     this.showSuccess = false;
    //     this.dataAvailable = false;
    //     this.noRecords = '';
    //     this.nofiltereddata = true;
    //     return false;
    //   }
    // }

    toggleAllClusterFilterSelection() {
      if (this.clusterFilterSelectedAll) {
        this.clusterFilterControl.options.forEach((item: MatOption) => item.select());
      } else {
        this.clusterFilterControl.options.forEach((item: MatOption) => item.deselect());
      }
    }

    toggleAllSiteFilterSelection() {
      if (this.siteFilterSelectedAll) {
        this.siteFiltercontrol.options.forEach((item: MatOption) => item.select());
      } else {
        this.siteFiltercontrol.options.forEach((item: MatOption) => item.deselect());
      }
    }

    toggleAllBigCategoryFilterSelection() {
      if (this.bigCategoryFilterSelectedAll) {
        this.bigCategoryFilterControl.options.forEach((item: MatOption) => item.select());
      } else {
        this.bigCategoryFilterControl.options.forEach((item: MatOption) => item.deselect());
      }
    }

    toggleAlluserFilterSelection() {
      if (this.userFilterSelectedAll) {
        this.userFilterControl.options.forEach((item: MatOption) => item.select());
      } else {
        this.userFilterControl.options.forEach((item: MatOption) => item.deselect());
      }
    }

    filterDatabyConditionchange() {
      const selectedclusterFilter = this.qamatrixDefects.get('clusterFilter').value;
      const selectedSiteFilter = this.qamatrixDefects.get('siteFilter').value;
      const selectedbigCategoryFilter = this.qamatrixDefects.get('bigCategoryFilter').value;
      const selectedUserFilter = this.qamatrixDefects.get('userFilter').value;
      const filterbyCluster: Array<PivotTableDetails> = [];
      const filterbySite: Array<PivotTableDetails> = [];
      const filterbybigCategory: Array<PivotTableDetails> = [];
      const filterbyUser: Array<PivotTableDetails> = [];
      if (this.pivotTableDetails != null && this.pivotTableDetails.length > 0) {
        this.filteredDataSource = this.pivotTableDetails;
        if (selectedclusterFilter !== null && selectedclusterFilter.length > 0) {
          this.filteredDataSource.forEach(x => {
            selectedclusterFilter.forEach(element => {
              if (x.cluster === element) {
                filterbyCluster.push(x);
              }
            });
          });
          this.filteredDataSource = filterbyCluster;
        } else {
          this.filteredDataSource = [];
        }
        if (selectedSiteFilter !== null && selectedSiteFilter.length > 0) {
          this.filteredDataSource.forEach(x => {
            selectedSiteFilter.forEach(element => {
              if (x.sites === element) {
                filterbySite.push(x);
              }
            });
          });
          this.filteredDataSource = filterbySite;
        } else {
          this.filteredDataSource = [];
        }
        if (selectedbigCategoryFilter !== null && selectedbigCategoryFilter.length > 0) {
          this.filteredDataSource.forEach(x => {
            selectedbigCategoryFilter.forEach(element => {
              if (x.bigcategory === element) {
                filterbybigCategory.push(x);
              }
            });
          });
          this.filteredDataSource = filterbybigCategory;
        } else {
          this.filteredDataSource = [];
        }
        if (selectedUserFilter !== null && selectedUserFilter.length > 0) {
          this.filteredDataSource.forEach(x => {
            selectedUserFilter.forEach(element => {
              if (x.createdby === element) {
                filterbyUser.push(x);
              }
            });
          });
          this.filteredDataSource = filterbyUser;
        }  else {
          this.filteredDataSource = [];
        }
        if (selectedclusterFilter.length === this.clusterfilter.length) {
            this.clusterFilterSelectedAll = true;
        } else {
          this.clusterFilterSelectedAll = false;
        }
        if (selectedSiteFilter.length === this.sitefilter.length) {
            this.siteFilterSelectedAll = true;
        } else {
          this.siteFilterSelectedAll = false;
        }
        if (selectedbigCategoryFilter.length === this.bigcategoryfilter.length) {
            this.bigCategoryFilterSelectedAll = true;
        } else {
          this.bigCategoryFilterSelectedAll = false;
        }
        if (selectedUserFilter.length === this.userfilter.length) {
          this.userFilterSelectedAll = true;
      } else {
        this.userFilterSelectedAll = false;
      }
        if (this.filteredDataSource.length === 0) {
          this.noRecords = 'No records';
          this.nofiltereddata = true;
        } else {
          this.nofiltereddata = false;
        }
      }
    }

    filterData() {
      this.showSuccess = false;
      if (this.pivotTableDetails != null && this.pivotTableDetails.length > 0) {
        this.filteredDataSource = this.pivotTableDetails;
        if (this.filteredDataSource.length === 0) {
          this.noRecords = 'No records';
          this.nofiltereddata = true;
        } else {
          const clusterArray = [];
          const siteArray = [];
          const bigcategoryArray = [];
          const userArray = [];
          this.filteredDataSource.forEach(x => {
            clusterArray.push(x.subregion);
            siteArray.push(x.sites);
            bigcategoryArray.push(x.businessgroup);
            userArray.push(x.createdby);
          });
          this.clusterfilter = clusterArray.filter((n, i) => clusterArray.indexOf(n) === i);
          this.sitefilter = siteArray.filter((n, i) => siteArray.indexOf(n) === i);
          this.bigcategoryfilter = bigcategoryArray.filter((n, i) => bigcategoryArray.indexOf(n) === i);
          this.userfilter = userArray.filter((n, i) => userArray.indexOf(n) === i);
          this.clusterfilterdefault = this.clusterfilter;
          this.sitefilterdefault = this.sitefilter;
          this.userfilterdefault = this.userfilter;
          this.bigcategoryfilterdefault = this.bigcategoryfilter;
          this.clusterFiltertooltip = this.clusterfilterdefault;
          this.siteFiltertooltip = this.sitefilterdefault;
          this.bigcategoryFiltertooltip = this.bigcategoryfilterdefault;
          this.userFiltertooltip = this.userfilterdefault;
          this.bigCategoryFilterSelectedAll = true;
          this.userFilterSelectedAll = true;
          this.siteFilterSelectedAll = true;
          this.clusterFilterSelectedAll = true;
          this.nofiltereddata = false;
        }
      }
    }

    exportExcel() {
      this.excelService.generateExcelForProjectStatusReport(this.filteredDataSource);
    }
}
